import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { PlatformApiService, ResultFilter, Results, PlanSearchCriteria } from '../../services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';
import { MatDialog } from '@angular/material/dialog';
import { BuyNowPromptComponent } from 'src/app/shared/buynow-prompt.component';
import { Account,Plan } from '../../models/AccountModel';
import { AssessmentService } from 'src/app/services/assessment.service';
import { Assessment, AccountAssessment } from 'src/app/models/AssessmentModel';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
import { AssessmentTypeListComponent } from 'src/app/secured/assessment/assessment-type-list.component';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'cw-ci-sub-account-summary-list',
  templateUrl: './sub-account-summary-list.component.html',
  styleUrls: ['./sub-account-summary-list.component.scss']
})
export class SubAccountSummaryListComponent implements OnInit {

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService, public assessmentService: AssessmentService, public dialog: MatDialog) { }

  @Input() parentAccount: Account;
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) accountDataTable: DataTableComponent;

  accountList: Results;
  availablePlans: Plan[];

  ngOnInit() {
  }

  isSelectable(account) {
    return account.isActive;
  }

  selectAccount(item) {
    this.stateChange.emit({ state: 'ASSESSMENT_LIST', item });
  }

  editAccount(account) {
    this.stateChange.emit({ state: 'SELECT', item: account });
  }

  deleteAccount(account) {
    const pMessage = account.isActive ? 'Are you sure you want to deactivate this company?' : 'Are you sure you want to permanently delete this company?';
    const statusMsg = account.isActive ? 'Deactivating company...' : 'Deleting company...';

    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptMessage: [pMessage],
        closeLabel: 'No',
        buttons: [{label:'Yes', value:'YES', color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm == 'YES') {
        this.accountDataTable.showProcessing(statusMsg);

        this._platformApi.deleteAccount(account.id).subscribe(
          resp => {
            this.accountDataTable.executeLoadItems();
          }
        );
      }
    });
  }

  refresh() {
    this.accountDataTable.executeLoadItems();
  }

  getRiskColor(score) {
    const aServ = new AssessmentService();
    return aServ.getRiskColor({score});
  }

  getRiskLabel(score) {
    const aServ = new AssessmentService();
    return aServ.getRiskLabel({score});
  }

  loadAccounts(filter = new ResultFilter()) {
    this.accountDataTable.showProcessing();
    filter.searchData.excludedAssessmentTypes = ['CERTIFICATION'];
    filter.searchData.include_parent = this._sessionService.getCurrentUser().getPreference('ui.includeMasterInCompanies').getBooleanValue();
    const accountListObservable = this._platformApi.getSubAccounts(this.parentAccount.id, filter);
    accountListObservable.subscribe(results => {
      this.accountList = results;
      console.log('SubAccountSummaryList.loadAccounts', results);
    })
  }

  newAccount(event?) {
    let allowCreate = false;

    if (this._sessionService.isAccountType('SYSTEM')) {
      allowCreate = true;
    } else {
      let numSubAccounts = this.accountList.count;
      if (this._sessionService.getCurrentUser().getPreference('ui.includeMasterInCompanies').getBooleanValue()) {
        numSubAccounts--;
      }

      const numAllowedAccounts = this._sessionService.getFeature('NUM_SUBACCOUNTS');
      if (numAllowedAccounts != undefined && numAllowedAccounts != null) {
        allowCreate = numSubAccounts < numAllowedAccounts;
      } else {
        allowCreate = true;
      }
    }

    if (!allowCreate) {
      const dialogRef = this.dialog.open(BuyNowPromptComponent, {
        panelClass: 'flush-dialog',
        data: { reason: 'FEATUREUNAVAILABLE', message: 'You have reached the company limit for your trial.  You can continue to provide high-value risk assessments for your other customers by upgrading to a paid subscription.' }
      });
    } else {
      this.stateChange.emit({ state: 'CREATE' });
    }
  }

  newAssessment(selectedAccount: Account) {
    if (this._sessionService.hasFeature('ALLOW_REASSESSMENT')) {
      let assessmentListObservable, assessmentList;
      assessmentListObservable = this._platformApi.getAccountAssessment(this.parentAccount.id, selectedAccount.id, selectedAccount.summary.recentAssessmentId)
      assessmentListObservable.subscribe(results => {
        assessmentList = results;
      })
      let cAccountId;
      let pAccountId = selectedAccount.parentId;
      if (pAccountId === null || pAccountId === undefined) {
          pAccountId = undefined
          cAccountId = selectedAccount.id
      }
      this._platformApi.getPlans(new PlanSearchCriteria(true, undefined, pAccountId, undefined, cAccountId)).subscribe(plans => {
        this.availablePlans = plans.results;
        const planObj = this.availablePlans[0];
        if (planObj) {
          this.accountDataTable.executeLoadItems();
          this._platformApi.getAssessments(new ResultFilter(undefined, undefined, undefined,undefined, {planId: selectedAccount.planSubscription.planId, isInTrial: selectedAccount.isInTrial(), excludeTypeList: ['CERTIFICATION'], accountId: selectedAccount.id}))
            .subscribe(assessmentTemplates => {
            if (assessmentTemplates.count > 1){
              const dialogRef = this.dialog.open(AssessmentTypeListComponent, {
                panelClass: 'flush-dialog',
                data: {planId: selectedAccount.planSubscription.planId, isInTrial: selectedAccount.isInTrial()},
                disableClose: false,
                autoFocus: false,
              });
              dialogRef.afterClosed().subscribe(selectedValue => {
                if (selectedValue != undefined) {
                  if (assessmentList.assessmentId == selectedValue.value) {
                    this.displayConfirmationComponent(selectedAccount);
                  } else {
                    this.newAssessmentSurvey(selectedAccount, selectedValue.value);
                  }
                }
              });
            } else {
                if (assessmentTemplates.results[0] && selectedAccount.summary.recentAssessmentTemplateId == assessmentTemplates.results[0].id) {
                  this.displayConfirmationComponent(selectedAccount);
                } else {
                  this.newAssessmentSurvey(selectedAccount, assessmentTemplates.results[0].id);
                }
            }
          });
        }
      });
    } else {
      let msg = 'You have reached the assessment limit for your trial.  Please upgrade to a paid subscription to provide unlimited assessments to all of your customers.';
      if (this._sessionService.getCurrentAccount().parentId) {
        msg = 'This feature is not currently available. Please contact your administrator for assistance.'
      }

      const dialogRef = this.dialog.open(BuyNowPromptComponent, {
        panelClass: 'flush-dialog',
        data: { reason: 'FEATUREUNAVAILABLE', message: msg }
      });
    }
  }

  newAssessmentSurvey(selectedAccount, selectedValue) {
    this._platformApi.getAccountAssessment(this.parentAccount.id, selectedAccount.id, selectedAccount.summary.recentAssessmentId).subscribe(loadedAssessment => {
      const newAccountAssessment = new AccountAssessment({
        accountId: selectedAccount.id,
        assessmentId: selectedValue,
        prevId: selectedAccount.summary.recentAssessmentId,
        surveyResultsJson: null
      });
      this._platformApi.saveAccountAssessment(this.parentAccount, newAccountAssessment).subscribe(accountAssessment => {
        loadedAssessment.nextId = accountAssessment.id;
        loadedAssessment.isLatest = false;
        this._platformApi.saveAccountAssessment(this.parentAccount, loadedAssessment).subscribe(prevAcctAssessment => {
          this.stateChange.emit({ state: 'EDIT_ASSESSMENT', accountAssessment, account: selectedAccount });
        });
      });
    });
  }

  // TODO: remove these and use base class
  workAssessment(selectedAssessment:AccountAssessment) {
    this.stateChange.emit({state:'EDIT_ASSESSMENT', account: selectedAssessment});
  }

  viewAssessmentDashboard(selectedAssessment: AccountAssessment) {
    this.stateChange.emit({ state: 'ASSESSMENT_REPORT', account: selectedAssessment });
  }

  showScanTargets(account) {
    this.stateChange.emit({ state: 'SHOW_SCAN_TARGETS', item: account });
  }

  displayConfirmationComponent(selectedAccount){
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptTitle: 'Copy Answers',
        promptMessage: [
          'Do you want to copy the existing answers for this assessment into the new assessment?'
        ],
        closeLabel: 'Cancel',
        buttons: [{label:'No', value:'NO', color:'primary'}, {label:'Yes', value:'YES', color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(keepAnswers => {
      if (keepAnswers != undefined) {
        const pAccountId = this.parentAccount ? this.parentAccount.id : selectedAccount.id;
        const aId = this.parentAccount ? selectedAccount.id : undefined;
        this._platformApi.getAccountAssessment(pAccountId, aId, selectedAccount.summary.recentAssessmentId).subscribe(loadedAssessment => {
          const newAccountAssessment = new AccountAssessment({
            accountId: loadedAssessment.accountId,
            assessmentId: loadedAssessment.assessmentId,
            prevId: loadedAssessment.id,
            surveyResultsJson: (keepAnswers == 'YES') ? loadedAssessment.surveyResultsJson : null
          });          
          this._platformApi.saveAccountAssessment(this.parentAccount, newAccountAssessment).subscribe(accountAssessment => {
            loadedAssessment.nextId = accountAssessment.id;
            loadedAssessment.isLatest = false;
            this._platformApi.saveAccountAssessment(this.parentAccount, loadedAssessment).subscribe(prevAcctAssessment => {
              this.stateChange.emit({ state: 'EDIT_ASSESSMENT', accountAssessment, account: selectedAccount });
            });
          })
        });
      }
    });
  }
}
